import Authorization from '../views/authorization/Authorization'
const backendmenu = [
    {
        path: '/',  component: Authorization,
        children: [
          {
            path: '/',
            name: 'Login',
            component: () => import(/* webpackChunkName: "Login" */ '../views/authorization/views/Login')
          },
          {
            path: '/verify',
            name: 'Verify',
            component: () => import(/* webpackChunkName: "Verify" */ '../views/authorization/views/Verify')
          },
          {
            path: '/forget',
            name: 'Verify',
            component: () => import(/* webpackChunkName: "Verify" */ '../views/authorization/views/Forget')
          },
          {
            path: '/setpassword',
            name: 'Verify',
            component: () => import(/* webpackChunkName: "Verify" */ '../views/authorization/views/SetNewPassword')
          },
        ]
    }
]

export default backendmenu;